import WrittenLocation from "@assets/images/edit-location.svg";
import Location from "@assets/images/Location-on.svg";
import { makeStyles } from "@material-ui/core/styles";
import { maybe } from "@saleor/misc";
import { OrderDetails_order } from "@saleor/motherOrders/types/OrderDetails";
import React from "react";

import { addressLineOne, addressLineThree, addressLineTwo } from "./handlers";

const useStyles = makeStyles(
  {
    distinction: {
      display: "flex"
    },
    leftSpacer: {
      marginLeft: "5px"
    },
    spacer: {
      marginBottom: "10px"
    },
    subSection: {
      display: "flex",
      flexDirection: "column",
      fontSize: "18px"
    },
    textBold: {
      fontSize: "18px",
      fontWeight: 600,
      whiteSpace: "nowrap"
    }
  },
  { name: "OrderAddress" }
);

export interface OrderAddressProps {
  order: OrderDetails_order;
}

const OrderAddress: React.FC<OrderAddressProps> = props => {
  const classes = useStyles(props);

  const { order } = props;

  return (
    <>
      <div id="cmpOrderAddress" className={classes.subSection}>
        <div className={classes.distinction}>
          <img src={Location} width={24} height={24} />
          <span
            id="txtOrderAddressPinnedAddress"
            className={`${classes.textBold} ${classes.leftSpacer}`}
          >
            Pinned Address
          </span>
        </div>
        <span id="txtOrderAddressLineTwoAddress">{addressLineTwo(order)}</span>
      </div>
      <div className={classes.spacer} />

      <div id="cmpOrderAddressWrittenLocation" className={classes.subSection}>
        <div className={classes.distinction}>
          <img src={WrittenLocation} width={24} height={24} />
          <span
            id="txtOrderAddressWrittenLocation"
            className={`${classes.textBold} ${classes.leftSpacer}`}
          >
            Written Address
          </span>
        </div>
        <span id="txtOrderAddressLineOneAddress">{addressLineOne(order)}</span>
        <span id="txtOrderAddressLineThreeAddress">
          {addressLineThree(order)}
        </span>
      </div>
      <div className={classes.spacer} />

      <div id="cmpOrderAddressLatAndLon" className={classes.subSection}>
        <span id="txtOrderAddressLatAndLonLabel" className={classes.textBold}>
          Latitude and Longitude
        </span>
        <span id="txtOrderAddressLatAndLon">
          {!maybe(() => order.shippingAddress.latitude)
            ? "--"
            : maybe(() => order.shippingAddress.latitude)}
          ,{" "}
          {!maybe(() => order.shippingAddress.longitude)
            ? "--"
            : maybe(() => order.shippingAddress.longitude)}
        </span>
      </div>
      <div className={classes.spacer} />

      <div id="cmpOrderAddressDistanceFromMall" className={classes.subSection}>
        <span id="txtOrderAddressDistanceFromMall" className={classes.textBold}>
          Distance from {maybe(() => order.mall.name)}
        </span>
        <span id="txtOrderAddressDistanceFromMallKM">
          {maybe(() => order.distanceFromMall)}KM
        </span>
      </div>
    </>
  );
};

export default OrderAddress;
